import { Column, Table } from "@tanstack/react-table"
import { useState } from "react"
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap"
import { ViewIcon } from "Components/atoms/icons"

interface ColumnVisibilityDropdownProps<T> {
    table: Table<T>
}

const columnLabel = <T,>(column: Column<T, unknown>) => {
    const header = column.columnDef.header
    return typeof header === "string" ? header : column.id
}

// "Columns" button with a checkbox per column. useDataTable saves the choice in this browser.
const ColumnVisibilityDropdown = <T,>({ table }: ColumnVisibilityDropdownProps<T>) => {
    const [isOpen, setIsOpen] = useState(false)

    // Action/control columns have no title: they always show
    const columns = table.getAllLeafColumns().filter(c =>
        c.getCanHide() && typeof c.columnDef.header === "string" && c.columnDef.header.trim() !== ""
    )
    if (columns.length < 2) return null

    const hiddenCount = columns.filter(c => !c.getIsVisible()).length

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(o => !o)} className="column-visibility-dropdown">
            <DropdownToggle tag="button" className="action-button" type="button">
                Columns{hiddenCount > 0 ? ` (${hiddenCount} hidden)` : ""} <ViewIcon />
            </DropdownToggle>
            <DropdownMenu end className="column-visibility-dropdown__menu">
                <div className="column-visibility-dropdown__actions">
                    <button type="button" className="btn btn-link btn-sm p-0" onClick={() => table.toggleAllColumnsVisible(true)}>
                        Show all
                    </button>
                </div>
                {columns.map(column => (
                    <label key={column.id} className="column-visibility-dropdown__item">
                        <input
                            type="checkbox"
                            className="form-check-input me-2"
                            checked={column.getIsVisible()}
                            onChange={column.getToggleVisibilityHandler()}
                        />
                        {columnLabel(column)}
                    </label>
                ))}
            </DropdownMenu>
        </Dropdown>
    )
}

export default ColumnVisibilityDropdown
